function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.38379 11.2109C10.5929 11.2109 12.3838 9.42008 12.3838 7.21094C12.3838 5.0018 10.5929 3.21094 8.38379 3.21094C6.17465 3.21094 4.38379 5.0018 4.38379 7.21094C4.38379 9.42008 6.17465 11.2109 8.38379 11.2109ZM8.38379 9.21094C9.48836 9.21094 10.3838 8.31551 10.3838 7.21094C10.3838 6.10637 9.48836 5.21094 8.38379 5.21094C7.27922 5.21094 6.38379 6.10637 6.38379 7.21094C6.38379 8.31551 7.27922 9.21094 8.38379 9.21094Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3838 14.2109C11.9361 14.2109 12.3838 14.6587 12.3838 15.2109V21.2109H14.3838V15.2109C14.3838 13.5541 13.0406 12.2109 11.3838 12.2109H5.38379C3.72693 12.2109 2.38379 13.5541 2.38379 15.2109V21.2109H4.38379V15.2109C4.38379 14.6587 4.8315 14.2109 5.38379 14.2109H11.3838Z",
  fill: "#4979C0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3838 11.2109H16.3838V13.2109H22.3838V11.2109Z",
  fill: "#4979C0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3838 15.2109H22.3838V17.2109H16.3838V15.2109Z",
  fill: "#4979C0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3838 7.21094H16.3838V9.21094H22.3838V7.21094Z",
  fill: "#4979C0"
});

var SvgForms = function SvgForms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forms.ecc7aa1f.svg";
export { ForwardRef as ReactComponent };